import { render, staticRenderFns } from "./paymentBill.vue?vue&type=template&id=2c39e80a&scoped=true&"
import script from "./paymentBill.vue?vue&type=script&lang=js&"
export * from "./paymentBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39e80a",
  null
  
)

export default component.exports